import { render, staticRenderFns } from "./SysMenu.vue?vue&type=template&id=2e0b646c&scoped=true&"
import script from "./SysMenu.vue?vue&type=script&lang=js&"
export * from "./SysMenu.vue?vue&type=script&lang=js&"
import style0 from "./SysMenu.vue?vue&type=style&index=0&id=2e0b646c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b646c",
  null
  
)

export default component.exports